import { MatDialogConfig } from '@angular/material/dialog';

export const DefaultModalConfigConstant: MatDialogConfig = {
  autoFocus: false,
  width: '618px',
};
